module.exports = __webpack_public_path__ + "img/ds_serve.b65b4731.png";